module.exports = __webpack_public_path__ + "static/media/noInformation02.1aef561b.png";